/* Next10 — pagina "Conheca os Cards": carrossel dos 6 cards e cards que viram. */
(function () {
  function iniciarCarrossel(raiz) {
    var slides = raiz.querySelectorAll('[data-n10cards-slide]');
    var pontos = raiz.querySelectorAll('[data-n10cards-ponto]');
    if (!slides.length) return;

    var atual = 0;

    function mostrar(i) {
      atual = (i + slides.length) % slides.length;
      for (var s = 0; s < slides.length; s++) {
        slides[s].classList.toggle('is-ativo', s === atual);
      }
      for (var p = 0; p < pontos.length; p++) {
        pontos[p].classList.toggle('is-ativo', p === atual);
        pontos[p].setAttribute('aria-current', p === atual ? 'true' : 'false');
      }
    }

    raiz.addEventListener('click', function (event) {
      var alvo = event.target.closest ? event.target.closest('[data-n10cards-nav], [data-n10cards-ponto]') : null;
      if (!alvo) return;
      if (alvo.hasAttribute('data-n10cards-ponto')) {
        mostrar(parseInt(alvo.getAttribute('data-n10cards-ponto'), 10) || 0);
      } else {
        mostrar(atual + (alvo.getAttribute('data-n10cards-nav') === 'next' ? 1 : -1));
      }
    });

    // arrastar de lado no celular
    var x0 = null;
    raiz.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    raiz.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) mostrar(atual + (dx < 0 ? 1 : -1));
      x0 = null;
    });

    mostrar(0);
  }

  function iniciarFlips(raiz) {
    raiz.addEventListener('click', function (event) {
      var botao = event.target.closest ? event.target.closest('[data-n10cards-flip]') : null;
      if (!botao) return;
      var virado = botao.classList.toggle('is-virado');
      botao.setAttribute('aria-pressed', virado ? 'true' : 'false');
    });
  }

  function iniciar() {
    var pagina = document.querySelector('.n10cards');
    if (!pagina) return;
    var carrossel = pagina.querySelector('[data-n10cards-carrossel]');
    if (carrossel) iniciarCarrossel(carrossel);
    iniciarFlips(pagina);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
